module.exports = __webpack_public_path__ + "static/media/Y9.5f4279e5.mp3";